<template>
  <div class="thousand_layout" v-loading="loading">
    <div class="">
      <div class="bids_tabs">
        <div @click="HistoryTabs(1)" :class="historyTab==1?'on':''">{{$t('base.unpaid')}}<span v-if="tabNumber.WaitPay>0">({{tabNumber.WaitPay}})</span></div>
        <div @click="HistoryTabs(2)" :class="historyTab==2?'on':''">{{$t('base.toBeShipped')}}<span v-if="tabNumber.WaitSend>0">({{tabNumber.WaitSend}})</span></div>
        <div @click="HistoryTabs(3)" :class="historyTab==3?'on':''">{{$t('base.shipped')}}<span v-if="tabNumber.WaitRereive>0">({{tabNumber.WaitRereive}})</span></div>
        <div @click="HistoryTabs(4)" :class="historyTab==4?'on':''">{{$t('base.completed')}}<span v-if="tabNumber.Complete>0">({{tabNumber.Complete}})</span></div>
      </div>
      <div>
        <el-form ref="historyForm" class="history_form" :model="form">
          <el-form-item class="history_form_item" :label="$t('base.title')">
            <el-input v-model="form.title" class="info_ipt" :placeholder="$t('base.itemTitle')"></el-input>
          </el-form-item>
          <el-form-item class="history_form_item" :label="$t('base.orderNum')">
            <el-input v-model="form.order" class="info_ipt" :placeholder="$t('base.orderNumber')"></el-input>
          </el-form-item>
          <!-- <el-form-item class="history_form_item" :label="$t('base.sellerName')">
            <el-input v-model="form.seller" class="info_ipt" :placeholder="$t('base.sellerName')"></el-input>
          </el-form-item> -->
          <el-button type="primary" class="history_form_btn" @click="submitForm('historyForm')">{{$t('base.search')}}</el-button>
        </el-form>
        <div>
          <div class="table_head">
            <div class="head_img head_box"></div>
            <div class="commod head_box">{{$t('base.item')}}</div>
            <div class="head_box itprice">{{$t('base.itemPrice')}}</div>
            <div class="head_box Quantity">{{$t('base.quantity')}}</div>
            <div class="head_box">{{$t('base.shippingFee')}}</div>
            <div class="head_box itprice">{{$t('base.orderTotal')}}</div>
            <div class="head_box tracking">{{$t('base.status')}}</div>
            <div class="head_box tracking">
              {{$t('base.operate')}}
                <el-tooltip v-if="historyTab==3" :content="$t('alert.checkeFinish')" placement="top">
                  <i class="el-icon-question"></i>
                </el-tooltip>
            </div>
          </div>
          <history-list :list="list" :type="historyTab" :arrived="isArrived" @getDialog="getDialog" />

        </div>
        <list-pagination class="pagination" :TotalCount="TotalCount" :ps="ps" @ps='pageSize' @pi='pageIndex' v-if="!ifData" />
        <n-o-t-n class="notfind" title="" :text="$t('base.noData')" v-else-if="resultTpye==1" />
        <f-z-f class="notfind" title="" :text="$t('base.pagefault')" v-else />
      </div>
    </div>
  </div>
</template>
<script>
import { getInfo } from "@/api/public";
import NOTN from "@/components/notnull.vue";
import HistoryList from "@/components/list/orderlist"
import ListPagination from '@/components/listpagination'
import FZF from "@/components/404.vue";

export default {
  name: 'tabslist',
  components: { ListPagination, HistoryList, NOTN, FZF },
  data() {
    return {
      loading: false,
      historyTab: 1,
      ifData: false,
      tabNumber: '',
      isArrived: 'All Status',
      list: {},
      arrived: this.$enumInfo.arrived,
      pi: 1,
      ps: 60,
      TotalCount: 0,
      form: {
        title: '',
        order: '',
        seller: '',
      },
      resultTpye: '',
      pSRType: ''
    }
  },
  props: {
    userInfo: {}
  },
  mounted() { },
  created() {
    this.historyTab = this.$route.query.type || 1;
    this.GetBuyStatistics()
    this.GetSearchSell()
  },
  methods: {
    // 获取订单列表
    /**
     * 获取订单列表数据
     * 根据用户ID、分页信息和订单状态查询订单记录
     * @description 发送GET请求获取订单列表，更新列表数据、总数和加载状态
     * @returns {void}
     */
    GetSearchSell() {
      let that = this;
      this.loading = true;
      let data = {memberid: that.userInfo.MappingUserId,pageIndex: that.pi, pageSize: that.ps, orderStatus: that.historyTab, orderCode:'',title:'',startTime: '', endTime: ''}
      this.$get(this.$interface.OrderList, data).then(res => {
      //console.log(res)
        if (res.Result != 0) {
          let result = res.Data;
          that.list = result;
          that.TotalCount = res.Count;
          if(res.ount == 0){
            this.ifData=true;
          }else{
            this.ifData=false
          }
        } else {
          this.ifData=true;
          that.list = null;
          that.TotalCount = 0
          this.loading = false
        }
        this.resultTpye = res.Result
        this.loading = false
      })
    },

    // 获取订单统计
    GetBuyStatistics() {
      let that = this
      let data = data = {  memberid: that.userInfo.MappingUserId }
      this.$get(this.$interface.GetMyOrderStatistics, data).then(res => {
        //console.log(res)
        if (res.Result != 0) {
          let result = res.Data;
          that.tabNumber = result
        }
      })
    },
    handleCommand(val) {
      this.isArrived = val;
      switch (val) {
        case 'All State':
          this.pSRType = '';
          break;
        case 'Disputing':
          this.pSRType = 1;
          break;
        case 'Disputed':
          this.pSRType = 2;
          break;
        case 'Revoke':
          this.pSRType = 3;
          break;
      }
      this.GetSearchSell()
    },
    getDialog() {
      this.GetSearchSell()
      this.GetBuyStatistics()
    },
    //订单列表筛选
    submitForm() {
      this.GetSearchSell()
      this.GetBuyStatistics()
    },
    // tab
    HistoryTabs(val) {
      this.historyTab = val;
      this.form = {
        title: '',
        order: '',
        seller: '',
      }
      this.GetSearchSell();
      this.GetBuyStatistics()
    },
    // 每页几条
    pageSize(val) {
      this.ps = val
      this.GetSearchSell();

    },
    // 页码
    pageIndex(val) {
      this.pi = val
      this.GetSearchSell();
    },
  }
}

</script>
<style scoped>
@import "../../../static/css/purchasehistory.css";

.pagination {
  margin-top: 20px;
}
.Quantity {
  width: 77px;
}
.isArrived {
  cursor: pointer;
}
.itprice {
  text-align: right;
}
.el-icon-question[data-v-0575cf1e] {
  color: #5f6dae;
}
</style>



// WEBPACK FOOTER //
// src/pages/user/mallorder.vue